import { Controller } from "@hotwired/stimulus"
import TurboFetch from "../turbo_fetch"

// Fires a TurboFetch GET at a configured URL, so the backend can respond with
// turbo_stream actions that do more than a frame swap — e.g. fill a modal frame
// AND open the modal. Used by the "Add Note" button.
//
//   <a data-controller="turbo-fetch"
//      data-turbo-fetch-url-value="/notes/new?entity_id=1"
//      data-action="click->turbo-fetch#get">Add Note</a>
export default class extends Controller {
  static values = { url: String }

  get(event) {
    event.preventDefault()
    TurboFetch.get(this.urlValue)
  }
}
